<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <p-toast position="bottom-right" key="br" />
  <p-confirmDialog key="statusChange"></p-confirmDialog>
  <header>
    <div class="headline">
      <h1>
        {{ 'Purchase_Order_Details_Title' | translateWF: 'Purchase Order' }}:
        {{ purchaseOrder ? purchaseOrder.purchaseOrderNumber : ('Purchase_Order_Details_Title_New' | translateWF: 'New') }}
      </h1>
      <csl-dropdown [formControl]="status" [enumObject]="statusEnumObject" [enumValueOptions]="workPurchaseOrderStatusOptions"></csl-dropdown>
    </div>
    <div class="buttons">
      <p-button
        severity="secondary"
        icon="pi pi-copy"
        *ngIf="purchaseOrder?.id"
        (click)="copyPurchaseOrder()"
        size="large"
        [pTooltip]="'Purchase_Order_Details_Copy' | translateWF: 'Copy Purchase Order'"
      ></p-button>
      <p-button severity="secondary" icon="pi pi-print" *ngIf="canPrintReport()" (click)="downloadReport()" size="large"></p-button>
      <button pButton class="cs-button-link" label="Manual" (click)="goToInternalLink()">
        <i class="pi pi-arrow-right"></i>
      </button>
      <span class="separator"></span>
      <p-button
        *ngIf="purchaseOrder ? purchaseOrder.status != 2 : true"
        [label]="'Save' | translateWF: 'Save'"
        (click)="savePurchaseOrder()"
        [disabled]="items.value.length <= 0 || !canEdit()"
      />
      <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" routerLink="/purchase-orders" />
    </div>
  </header>

  <div class="content">
    <div class="grid-12-lg">
      <div class="col" [ngClass]="{ 'span-8': drawerView, 'span-11': !drawerView }">
        <!-- Notes section (Common for both types) -->
        <p-panel header="Notes">
          <csl-standard-notes [userLite]="userLite!" [notes]="notes" (viewMore)="onViewMore()" />
        </p-panel>

        <p-panel [header]="'Purchase_Order_Details_General_Information' | translateWF: 'General Information'">
          <ng-template pTemplate="icons">
            @if (!purchaseOrder?.id && type.enabled) {
              <p-select [formControl]="type" [options]="setOptionsForPrimeNg(this.orderTypeEnums)"></p-select>
            } @else if (purchaseOrder?.id) {
              <p-tag [value]="orderTypeEnums[purchaseOrder!.type]"></p-tag>
            } @else {
              <p-tag [value]="orderTypeEnums[type.value!]"></p-tag>
            }
          </ng-template>
          <p-card>
            <div class="col">
              <div id="general-details">
                <div class="col">
                  <!-- Top row: Date Created | Provider | Provider Address -->
                  <div class="grid-auto-3">
                    <div class="form-box">
                      <label for="">{{ 'Purchase_Order_Date_Created' | translateWF: 'Date Created' }}</label>
                      <input type="date" class="w-full p-inputtext p-component" [disabled]="true" [value]="formatDate(purchaseOrder?.createdDate ?? currentDate)" />
                    </div>

                    <div class="form-box">
                      <label for="" class="required">{{ 'Purchase_Order_Details_Provider' | translateWF: 'Provider' }}</label>

                      <p-autoComplete
                        fluid
                        class="provider-autocomplete"
                        [ngClass]="{ 'ng-invalid ng-dirty': provider.invalid && provider.touched }"
                        [suggestions]="providers"
                        [formControl]="provider"
                        dropdownIcon="pi pi-search"
                        [forceSelection]="true"
                        optionLabel="fieldToDisplay"
                        [dropdown]="true"
                        (completeMethod)="providerChange($event)"
                        [appendTo]="'body'"
                      >
                      </p-autoComplete>
                      <small id="provider" *ngIf="provider.value?.code">{{ provider.value?.code }}</small>
                    </div>

                    <div class="form-box">
                      <label for="" class="required">{{
                        'PurchaseOrderDetails_Provider_Address'
                          | translateWF
                            : 'Provider
                        Address'
                      }}</label>
                      <p-select
                        [options]="providerAddresses"
                        [formControl]="providerAddress"
                        optionLabel="displayName"
                        styleClass="w-full"
                        [ngClass]="{ 'ng-invalid ng-dirty': providerAddress.invalid && providerAddress.dirty && providerAddress.enabled }"
                        [placeholder]="provider.value ? ('Select_Address' | translateWF: 'Select Address') : ('Select_Provider_First' | translateWF: 'Select a provider first')"
                      >
                      </p-select>
                    </div>
                  </div>

                  <div class="span-6"></div>
                </div>
                <!-- Dates row: Issued Date and Quoted Date placed under the top row (readonly, always today's date) -->
                <div class="grid-auto-2">
                  <div class="form-box">
                    <label class="required" for="issuedDate">{{
                      'PurchaseOrder_IssuedDate'
                        | translateWF
                          : 'Issued
                      Date'
                    }}</label>
                    <input type="date" class="w-full p-inputtext p-component" id="issuedDate" [disabled]="true" [value]="formatDate(issuedDate)" />
                  </div>
                  <div class="form-box">
                    <label for="quotedDate">{{ 'PurchaseOrder_QuotedDate' | translateWF: 'Quoted Date' }}</label>
                    <input type="date" class="w-full p-inputtext p-component" id="quotedDate" [disabled]="true" [value]="formatDate(quotedDate)" />
                  </div>
                </div>
                <!-- Nueva fila para Maker -->
              </div>
            </div>
          </p-card>
        </p-panel>

        <!-- Bill To section (Common for both types) -->
        <p-panel [header]="'Bill_To' | translateWF: 'Bill To'">
          <p-card>
            <div class="grid-12">
              <div class="span-6">
                <div class="row">
                  <div class="form-box">
                    <label for="">{{ 'Currency' | translateWF: 'Currency' }}</label>
                    @if (!purchaseOrder?.id) {
                      <p-select [formControl]="currency" [options]="setOptionsForPrimeNg(this.currencyEnum)" (onChange)="fetchCurrencyExchangeRateToUSD()"></p-select>
                    } @else {
                      <p>{{ currencyEnum[purchaseOrder!.currency] }}</p>
                    }
                  </div>
                  <div class="form-box" *ngIf="purchaseOrder?.id ? purchaseOrder?.currency != 0 : currency.value != 0">
                    <label for="">{{ 'ExchangeRate' | translateWF: 'Exchange Rate' }}</label>
                    <div class="form-box-row">
                      @if (!purchaseOrder?.id) {
                        <p-inputnumber [formControl]="exchangeRateToUSD" [minFractionDigits]="2" [maxFractionDigits]="25" />
                        <p-button [label]="'Reload' | translateWF: 'Reload'" (onClick)="fetchCurrencyExchangeRateToUSD()"></p-button>
                      } @else {
                        <p>{{ purchaseOrder!.exchangeRateToUSD }}</p>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="span-6"></div>
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Search_Business' | translateWF: 'Search Business' }}</label>
                  <p-autoComplete
                    class="w-full"
                    fluid
                    dropdownIcon="pi pi-search"
                    [forceSelection]="true"
                    [suggestions]="billToProviders"
                    [formControl]="billToProvider"
                    optionLabel="fieldToDisplay"
                    [dropdown]="true"
                    (completeMethod)="billToProviderChange($event)"
                  >
                  </p-autoComplete>
                  <small id="billToProvider" *ngIf="billToProvider.value?.code">{{ billToProvider.value?.code }}</small>
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Address' | translateWF: 'Address' }}</label>
                  <p-select
                    [options]="billToAddresses"
                    [formControl]="billToAddress"
                    optionLabel="displayName"
                    styleClass="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': billToAddress.invalid && billToAddress.dirty && billToAddress.enabled }"
                    [placeholder]="billToProvider.value ? ('Select_Address' | translateWF: 'Select Address') : ('Select_Provider_First' | translateWF: 'Select a provider first')"
                  >
                  </p-select>
                </div>
              </div>
            </div>
            <div class="grid-12 mt-5">
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Payment_Mode' | translateWF: 'Payment Mode' }}</label>
                  <csl-dropdown-master-data
                    class="w-full required"
                    [formControl]="paymentMethod"
                    categoryCode="PaymentMode"
                    (onDelete)="handleDelete($event)"
                    (emitMessagesApi)="showMessagesApi($event)"
                    [allowCreate]="false"
                  />
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Payment_Terms' | translateWF: 'Payment Terms' }}</label>
                  <csl-dropdown-master-data
                    class="w-full required"
                    [formControl]="paymentTerms"
                    categoryCode="PaymentTermsProvider"
                    (onDelete)="handleDelete($event)"
                    (emitMessagesApi)="showMessagesApi($event)"
                    [allowCreate]="false"
                  />
                </div>
              </div>
            </div>
          </p-card>
        </p-panel>

        <!-- Ship To section (Common for both types) -->
        <p-panel [header]="'Ship_To' | translateWF: 'Ship To'">
          <p-card>
            <div class="grid-12">
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Search_Business' | translateWF: 'Search Business' }}</label>
                  <p-autoComplete
                    class="w-full required"
                    fluid
                    dropdownIcon="pi pi-search"
                    [suggestions]="shipToProviders"
                    [forceSelection]="true"
                    [formControl]="shipToProvider"
                    optionLabel="fieldToDisplay"
                    [dropdown]="true"
                    (completeMethod)="shipToProviderChange($event)"
                  >
                  </p-autoComplete>
                  <small id="shipToProvider" *ngIf="shipToProvider.value?.code">{{ shipToProvider.value?.code }}</small>
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Address' | translateWF: 'Address' }}</label>
                  <p-select
                    [options]="shipToAddresses"
                    [formControl]="shipToAddress"
                    optionLabel="displayName"
                    styleClass="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': shipToAddress.invalid && shipToAddress.dirty && shipToAddress.enabled }"
                    [placeholder]="shipToProvider.value ? ('Select_Address' | translateWF: 'Select Address') : ('Select_Provider_First' | translateWF: 'Select a provider first')"
                  >
                  </p-select>
                </div>
              </div>
            </div>
            <div class="grid-12 mt-5">
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Shipping_Method' | translateWF: 'Shipping Method' }}</label>
                  <csl-dropdown-master-data
                    class="w-full required"
                    [formControl]="shippingMethod"
                    categoryCode="ShippingMethod"
                    (onDelete)="handleDelete($event)"
                    (emitMessagesApi)="showMessagesApi($event)"
                    [allowCreate]="false"
                  />
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label for="" class="required">{{ 'Shipping_Terms' | translateWF: 'Shipping Terms' }}</label>
                  <p-select
                    [formControl]="shippingTerms"
                    [options]="setOptionsForPrimeNg(this.workOrderShipmentTypeEnums)"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Select_Shipping_Terms' | translateWF: 'Select shipping terms'"
                    class="w-full required"
                  />
                </div>
              </div>
            </div>
          </p-card>
        </p-panel>

        <!-- Destination Warehouses section (Standard Purchase Orders Only) -->
        @if (followsStandardFlow) {
          <p-panel [header]="'Destination_Warehouses' | translateWF: 'Destination Warehouses'">
            <p-card>
              <!-- Show from saved PO if available -->
              @if (purchaseOrder?.destinationLocationCodes?.length) {
                <div class="flex flex-wrap gap-2 mt-3">
                  @for (locationCode of purchaseOrder!.destinationLocationCodes; track $index) {
                    <p-tag
                      [value]="purchaseOrder!.destinationLocationNames?.[$index]?.en || purchaseOrder!.destinationLocationNames?.[$index]?.es || locationCode"
                      severity="info"
                      icon="pi pi-warehouse"
                    />
                  }
                </div>
                <p-message severity="secondary" class="text-gray-500 mt-2 block">
                  <i class="pi pi-info-circle"></i>
                  {{
                    'Destination_Warehouses_Info'
                      | translateWF
                        : 'These warehouses are determined by the associated
              requisitions'
                  }}
                </p-message>
              } @else if (destinationLocationsFromRequisitions.length) {
                <!-- Show from associated requisitions when creating new PO -->
                <div class="flex flex-wrap gap-2 mt-3">
                  @for (location of destinationLocationsFromRequisitions; track location.code) {
                    <p-tag [value]="location.name" severity="info" icon="pi pi-warehouse" />
                  }
                </div>
                <p-message severity="secondary" class="text-gray-500 mt-2 block">
                  <i class="pi pi-info-circle"></i>
                  {{
                    'Destination_Warehouses_Info'
                      | translateWF
                        : 'These warehouses are determined by the associated
              requisitions'
                  }}
                </p-message>
              } @else {
                <!-- Manual selection when no requisitions are associated -->
                <div class="form-box mt-3">
                  <label for="destinationLocation" class="required">{{
                    'Select_Destination_Warehouse'
                      | translateWF
                        : 'Select
                Destination Warehouse'
                  }}</label>
                  <p-select
                    id="destinationLocation"
                    [formControl]="destinationLocationCode"
                    [options]="destinationLocationOptions"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Select_Destination_Warehouse_Placeholder' | translateWF: 'Select a destination warehouse...'"
                    styleClass="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': destinationLocationCode.invalid && destinationLocationCode.touched }"
                  />
                  <p-message severity="secondary" class="text-gray-500 mt-1 block">
                    <i class="pi pi-info-circle"></i>
                    {{
                      'Destination_Warehouse_Info'
                        | translateWF
                          : 'Select where the items from this PO should be
                received'
                    }}
                  </p-message>
                </div>
              }
            </p-card>
          </p-panel>
        }

        <!-- Manufacturer section (Yarn and Chemical Purchase Orders) -->
        @if (isYarnPurchaseOrder || isChemicalPurchaseOrder) {
          <p-panel [header]="('Manufacturer' | translateWF: 'Manufacturer') + '(s)'">
            <p-card>
              <div class="grid-1 gap-5 mt-5">
                <div class="form-box-row row-start-center">
                  <p-checkbox inputId="manufacturerSameAsProvider" [binary]="true" [formControl]="manufacturerSameAsProvider"></p-checkbox>
                  <label for="manufacturerSameAsProvider" class="ml-2">{{
                    'Same_As_Provider'
                      | translateWF
                        : 'Same as
                  Provider'
                  }}</label>
                </div>
                <div class="form-box" *ngIf="!manufacturerSameAsProvider.value">
                  <label for="">{{ 'Add_Manufacturer' | translateWF: 'Add Manufacturer' }}</label>
                  <p-autoComplete
                    fluid
                    class="w-full"
                    [suggestions]="makersToDisplay"
                    [formControl]="manufacturer"
                    dropdownIcon="pi pi-search"
                    [forceSelection]="true"
                    optionLabel="fieldToDisplay"
                    [dropdown]="true"
                    (onSelect)="onSelectMaker($event)"
                    (completeMethod)="searchMaker($event)"
                  >
                  </p-autoComplete>
                </div>

                <div *ngIf="!manufacturerSameAsProvider.value">
                  <ng-container *ngFor="let manufacturer of manufacturers; let i = index">
                    <p-tag [value]="manufacturer.fieldToDisplay" class="mr-2">
                      @if (canEdit()) {
                        <button type="button" class="ml-1 p-button p-button-icon-only p-button-text" (click)="removeManufacturer(i)" pTooltip="Remove">
                          <i class="pi pi-times"></i>
                        </button>
                      }
                    </p-tag>
                  </ng-container>
                </div>
              </div>
            </p-card>
          </p-panel>
        }

        <!-- Associated entities section (Work Orders for Yarn, Quotations for Standard) -->
        <p-panel [header]="'Associated_Entities' | translateWF: 'Associated Entities'">
          <p-card>
            <div class="col">
              <!-- YARN PO: Work Orders -->
              @if (isYarnPurchaseOrder) {
                <div class="form-box-row">
                  <div class="form-box">
                    <label for="">{{ 'Entity' | translateWF: 'Entity' }}</label>
                    <p-select [options]="entities" [formControl]="formControlEntity" styleClass="min-w-[270px] w-full" />
                  </div>
                  <div class="form-box" *ngIf="formControlEntity.value !== null">
                    <label for="">{{ 'Search' | translateWF: 'Search' }}</label>
                    @switch (formControlEntity.value) {
                      @case (workOrderEntityCode) {
                        <p-autoComplete
                          fluid
                          dropdownIcon="pi pi-search"
                          styleClass="min-w-[300px] w-full"
                          [dropdown]="true"
                          optionLabel="orderNumber"
                          [formControl]="formControlWorkOrder"
                          [suggestions]="suggestionWorkOrders"
                          (completeMethod)="searchWorkOrders($event)"
                          (onSelect)="onSelectWorkOrder($event)"
                        />
                      }
                    }
                  </div>
                </div>

                <p-scrollpanel [style]="{ width: '100%', height: '150px' }">
                  <ul class="col w-1/3">
                    @if (associateWorkOrders.length > 0) {
                      @for (workOrder of associateWorkOrders; track $index) {
                        <li class="shipment-item">
                          <i>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="35" viewBox="0 0 24 24">
                              <path
                                fill="#5aa29d"
                                fill-rule="evenodd"
                                d="M4.172 3.172C3 4.343 3 6.229 3 10v4c0 3.771 0 5.657 1.172 6.828S7.229 22 11 22h2c3.771 0 5.657 0 6.828-1.172S21 17.771 21 14v-4c0-3.771 0-5.657-1.172-6.828S16.771 2 13 2h-2C7.229 2 5.343 2 4.172 3.172M7.25 8A.75.75 0 0 1 8 7.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8m0 4a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M8 15.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </i>
                          <p>{{ workOrder.orderNumber }}</p>
                          @if (canEdit()) {
                            <p-button icon="pi pi-trash" [rounded]="true" [raised]="true" [outlined]="true" (click)="removeWorkOrder(workOrder)" pTooltip="Remove" />
                          }
                        </li>
                      }
                    } @else {
                      <li class="shipment-item">
                        {{
                          'Purchase_Order_Details_No_Linked_Work_Orders'
                            | translateWF
                              : 'No Linked Work
                    Orders'
                        }}
                      </li>
                    }
                  </ul>
                </p-scrollpanel>
              }

              <!-- CHEMICAL PO: Client Purchase Orders -->
              @if (isChemicalPurchaseOrder) {
                <div class="form-box-row">
                  <div class="form-box">
                    <label>{{ 'Entity' | translateWF: 'Entity' }}</label>
                    <p-select [options]="entities" [formControl]="formControlEntity" styleClass="min-w-[270px] w-full" />
                  </div>
                  <div class="form-box" *ngIf="formControlEntity.value !== null">
                    <label>{{ 'Search' | translateWF: 'Search' }}</label>
                    @switch (formControlEntity.value) {
                      @case (clientPOEntityCode) {
                        <p-autoComplete
                          fluid
                          dropdownIcon="pi pi-search"
                          styleClass="min-w-[300px] w-full"
                          [dropdown]="true"
                          optionLabel="fieldToDisplay"
                          [formControl]="formControlClientPO"
                          [suggestions]="suggestedClientPOs"
                          (completeMethod)="searchClientPurchaseOrders($event)"
                          (onSelect)="onSelectClientPO($event)"
                        />
                      }
                    }
                  </div>
                </div>

                <p-scrollpanel [style]="{ width: '100%', height: '150px' }">
                  <ul class="col w-1/3">
                    @if (associatedClientPOs.length > 0) {
                      @for (cpo of associatedClientPOs; track $index) {
                        <li class="shipment-item">
                          <i>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="35" viewBox="0 0 24 24">
                              <path
                                fill="#5aa29d"
                                fill-rule="evenodd"
                                d="M4.172 3.172C3 4.343 3 6.229 3 10v4c0 3.771 0 5.657 1.172 6.828S7.229 22 11 22h2c3.771 0 5.657 0 6.828-1.172S21 17.771 21 14v-4c0-3.771 0-5.657-1.172-6.828S16.771 2 13 2h-2C7.229 2 5.343 2 4.172 3.172M7.25 8A.75.75 0 0 1 8 7.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8m0 4a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M8 15.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </i>
                          <p>{{ cpo.number }}</p>
                          @if (canEdit()) {
                            <p-button icon="pi pi-trash" [rounded]="true" [raised]="true" [outlined]="true" (click)="removeClientPO($index)" pTooltip="Remove" />
                          }
                        </li>
                      }
                    } @else {
                      <li class="shipment-item">
                        {{
                          'Purchase_Order_Details_No_Linked_Client_POs'
                            | translateWF
                              : 'No Linked
                    Client Purchase Orders'
                        }}
                      </li>
                    }
                  </ul>
                </p-scrollpanel>
              }

              <!-- STANDARD PO: Quotation + Requisitions -->
              @if (followsStandardFlow) {
                <!-- PASO 1: Seleccionar LA Quotation -->
                <div class="form-box-row">
                  <div class="form-box">
                    <label for="" [class.required]="!selectedQuotation">{{ 'Purchase_Order_Details_Select_Quotation' | translateWF: 'Select Quotation' }}</label>
                    <p-autoComplete
                      fluid
                      dropdownIcon="pi pi-search"
                      styleClass="min-w-[400px] w-full"
                      [dropdown]="true"
                      optionLabel="fieldToDisplay"
                      [formControl]="formControlQuotation"
                      [suggestions]="suggestedQuotations"
                      [disabled]="selectedQuotation !== null"
                      (completeMethod)="searchQuotations($event)"
                      (onSelect)="onSelectQuotation($event)"
                      [placeholder]="'Purchase_Order_Details_Search_Quotation_Placeholder' | translateWF: 'Search quotation by number or provider...'"
                    />
                    <small *ngIf="selectedQuotation" class="text-green-600">
                      <i class="pi pi-lock"></i> {{ 'Purchase_Order_Provider' | translateWF: 'Provider' }}: {{ selectedQuotation.providerName }} ({{
                        'Purchase_Order_Details_Locked' | translateWF: 'locked'
                      }})
                    </small>
                  </div>
                </div>

                <!-- PASO 2: Mostrar la Quotation Seleccionada -->
                @if (selectedQuotation) {
                  <div class="quotation-card p-4 border rounded-lg bg-gray-50">
                    <div class="flex items-start gap-4">
                      <i class="text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                          <path fill="#5aa29d" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z" />
                        </svg>
                      </i>
                      <div class="flex-1">
                        <h3 class="text-lg font-bold text-primary">{{ selectedQuotation.number }}</h3>
                        <div class="grid-2-sm mt-2 text-sm">
                          <p>
                            <strong>{{ 'Purchase_Order_Provider' | translateWF: 'Provider' }}:</strong> {{ selectedQuotation.providerName }}
                          </p>
                          <p>
                            <strong>{{ 'Purchase_Order_Items' | translateWF: 'Items' }}:</strong> {{ selectedQuotation.items.length }}
                          </p>
                          <p>
                            <strong>{{ 'Purchase_Order_Details_Currency' | translateWF: 'Currency' }}:</strong> {{ currencyEnum[selectedQuotation.currency] }}
                          </p>
                          <p>
                            <strong>{{ 'Purchase_Order_Details_Expiration' | translateWF: 'Expiration' }}:</strong> {{ selectedQuotation.expirationDate | date }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- PASO 3: Agregar Requisitions Adicionales -->
                  <div class="form-box-row" *ngIf="canEdit()">
                    <div class="form-box">
                      <label for="">{{
                        'Purchase_Order_Details_Add_Requisitions_Optional'
                          | translateWF
                            : 'Add Additional
                    Requisitions (Optional)'
                      }}</label>
                      <p-autoComplete
                        fluid
                        dropdownIcon="pi pi-search"
                        styleClass="min-w-[400px] w-full"
                        [dropdown]="true"
                        optionLabel="fieldToDisplay"
                        [formControl]="formControlRequisition"
                        [suggestions]="suggestedRequisitions"
                        (completeMethod)="searchApprovedRequisitions($event)"
                        (onSelect)="onSelectRequisition($event)"
                        [placeholder]="'Purchase_Order_Details_Search_Requisitions_Placeholder' | translateWF: 'Search approved requisitions...'"
                      />
                      <p-message severity="secondary" class="row-start-center help-text text-gray-500">
                        <i class="pi pi-info-circle"></i>
                        <span>{{
                          'Purchase_Order_Details_Requisitions_Help_Text'
                            | translateWF
                              : 'Only approved requisitions with items
                      from the selected quotation'
                        }}</span>
                      </p-message>
                    </div>
                  </div>

                  <!-- PASO 4: Lista de Requisitions Asociadas -->
                  @if (associatedRequisitions.length > 0) {
                    <div>
                      <h4 class="mb-3 font-semibold">
                        {{ 'Purchase_Order_Details_Associated_Requisitions' | translateWF: 'Associated Requisitions' }} ({{ associatedRequisitions.length }})
                      </h4>
                      <p-scrollpanel [style]="{ width: '100%', height: '200px' }">
                        <ul class="col">
                          @for (requisition of associatedRequisitions; let i = $index; track requisition.id) {
                            <li class="requisition-item p-3 border rounded-lg bg-white hover:bg-gray-50 transition-colors">
                              <div class="row-start-center gap-3">
                                <i>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="35" viewBox="0 0 24 24">
                                    <path fill="#5aa29d" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z" />
                                  </svg>
                                </i>
                                <div class="flex-1">
                                  <p class="font-semibold">{{ requisition.number }}</p>
                                  <p class="text-sm text-gray-600">
                                    {{ 'Purchase_Order_Details_Department' | translateWF: 'Department' }}:
                                    {{ requisition.departmentName || 'N/A' }}
                                  </p>
                                  <p class="text-sm text-gray-600">{{ 'Purchase_Order_Items' | translateWF: 'Items' }}: {{ requisition.entries.length || 0 }}</p>
                                </div>
                                @if (canEdit()) {
                                  <p-button
                                    icon="pi pi-trash"
                                    [rounded]="true"
                                    [outlined]="true"
                                    severity="danger"
                                    size="small"
                                    (click)="removeRequisition(requisition)"
                                    [pTooltip]="'Purchase_Order_Details_Remove_Requisition' | translateWF: 'Remove Requisition'"
                                  />
                                }
                                @if (i === 0) {
                                  <p-tag
                                    [value]="'Purchase_Order_Details_Original' | translateWF: 'Original'"
                                    severity="info"
                                    [pTooltip]="'Purchase_Order_Details_Original_Requisition_Tooltip' | translateWF: 'This is the requisition that originated the quotation'"
                                  />
                                }
                              </div>
                            </li>
                          }
                        </ul>
                      </p-scrollpanel>
                    </div>
                  }
                } @else {
                  <p-message severity="secondary" class="text-center text-gray-500">
                    <i class="pi pi-info-circle"></i> {{ 'Purchase_Order_Details_Select_Quotation_Message' | translateWF: 'Please select a Quotation to continue' }}
                  </p-message>
                }
              }
            </div>
          </p-card>
        </p-panel>

        <!-- Shipments section (Yarn and Chemical Purchase Orders) -->
        @if (isYarnPurchaseOrder || isChemicalPurchaseOrder) {
          <p-panel [header]="'Purchase_Order_Details_Shipments' | translateWF: 'Shipments'">
            <p-card>
              @if (!showShipments) {
                <div class="grid-2 gap-5">
                  <div class="">
                    <p-scrollpanel [style]="{ width: '100%', height: '150px' }">
                      <ul class="col">
                        @if (allShipments.length > 0) {
                          @for (shipment of allShipments; track $index) {
                            <li class="shipment-item" (click)="openShipmentDetailModal(shipment)">
                              <i>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                  <path
                                    fill="#5aa29d"
                                    d="m22.031 10.875l-2.136-3.543a1.76 1.76 0 0 0-1.497-.846h-1.677v-.249a2.73 2.73 0 0 0-.804-1.935a2.75 2.75 0 0 0-1.94-.802H3.994a2.73 2.73 0 0 0-2.541 1.687a2.7 2.7 0 0 0-.204 1.05v8.958a1.74 1.74 0 0 0 1.507 1.722q-.007.135 0 .269a3.15 3.15 0 0 0 .948 2.279A3.24 3.24 0 0 0 6 20.46a3.28 3.28 0 0 0 2.285-.956a3.26 3.26 0 0 0 .96-2.279a2 2 0 0 0 0-.248h5.509a2 2 0 0 0 0 .248a3.15 3.15 0 0 0 .948 2.28A3.24 3.24 0 0 0 18 20.5a3.28 3.28 0 0 0 2.285-.956a3.26 3.26 0 0 0 .959-2.279a2 2 0 0 0 0-.249H22a.76.76 0 0 0 .749-.746v-2.876c0-.89-.25-1.762-.719-2.519m-14.293 6.31a1.7 1.7 0 0 1-.519 1.225a1.79 1.79 0 0 1-2.466 0a1.73 1.73 0 0 1-.508-1.234a1.6 1.6 0 0 1 .14-.687c.132-.313.359-.577.648-.757a1.74 1.74 0 0 1 .998-.288c.338 0 .668.1.948.288c.287.183.513.446.65.757c.098.215.15.45.149.687zm3.244-4.976h-4.99a1 1 0 0 1-.999-.995a.994.994 0 0 1 .998-.996h4.991a1 1 0 0 1 .998.996a.994.994 0 0 1-.998.995m0-3.424h-4.99a1 1 0 0 1-.999-.995a.994.994 0 0 1 .998-.995h4.991a1 1 0 0 1 .998.995a.994.994 0 0 1-.998.995m8.734 8.4a1.7 1.7 0 0 1-.52 1.225a1.79 1.79 0 0 1-2.465 0a1.73 1.73 0 0 1-.509-1.234a1.64 1.64 0 0 1 .33-1.006c.246-.327.599-.56.998-.657h.25a.3.3 0 0 1 .139 0h.2c.303.035.592.148.838.329c.247.181.44.425.559.707c.099.215.15.45.15.686z"
                                  />
                                  <path fill="#5aa29d" d="M17.96 15.434a.3.3 0 0 0-.14 0z" />
                                </svg>
                              </i>
                              <p>
                                {{ shipment.shipmentNumber }}
                              </p>
                            </li>
                          }
                        }
                      </ul>
                    </p-scrollpanel>
                  </div>
                </div>
              }
            </p-card>
          </p-panel>
        }

        <!-- Items section (Common for both types) -->
        <p-panel [header]="'Purchase_Order_Details_Items' | translateWF: 'Items'">
          <ng-template pTemplate="icons">
            @if (!WorkOrderSelectedToSearch.value) {
              <p-autocomplete
                [dropdown]="true"
                dropdownIcon="pi pi-search"
                [suggestions]="filteredItems"
                field="fieldToDisplay"
                [style]="{ minWidth: '30rem' }"
                (completeMethod)="getItemOptions($event)"
                (onSelect)="onSelectItem($event)"
                [formControl]="searchItemInput"
                appendTo="body"
                [panelStyle]="{ minWidth: 'max-content' }"
              />
            }

            @if (WorkOrderSelectedToSearch.value && formControlEntity.value) {
              @switch (formControlEntity.value) {
                @case (workOrderEntityCode) {
                  @if (canEdit()) {
                    <p-autocomplete
                      [dropdown]="true"
                      dropdownIcon="pi pi-search"
                      [suggestions]="filteredEntities"
                      field="fieldToDisplay"
                      [style]="{ minWidth: '30rem' }"
                      (completeMethod)="searchParamsByWorkOrder($event)"
                      (onSelect)="onSelectItem($event)"
                    >
                    </p-autocomplete>
                  }
                }
              }
            }

            @if (associateWorkOrders.length > 0) {
              <p-select [options]="associateWorkOrders" optionLabel="orderNumber" [formControl]="WorkOrderSelectedToSearch" [showClear]="true" />
            }

            <p-select
              [formControl]="itemCategoryFilter"
              [placeholder]="'Purchase_Order_Details_All' | translateWF: 'All'"
              [options]="itemsCategories()"
              optionLabel="fieldToDisplay"
            />
          </ng-template>
          <p-card>
            @if (items.value.length > 0) {
              <p-table [value]="items.controls" [responsiveLayout]="'scroll'">
                <ng-template pTemplate="header">
                  <tr>
                    <th colspan="4" style="width: 16rem">
                      {{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}
                    </th>
                    @if (this.followsStandardFlow && (this.quotation || this.associatedRequisitions.length > 0)) {
                      <th>{{ 'Purchase_Order_Details_Requisition' | translateWF: 'Requisition' }}</th>
                    }
                    <!-- <th></th> -->
                    <th>{{ 'Purchase_Order_Details_Quantity' | translateWF: 'Quantity' }}</th>
                    <th>{{ 'Purchase_Order_Details_Item_Price' | translateWF: 'Item Price' }}</th>
                    @if (this.followsStandardFlow) {
                      <th>{{ 'Purchase_Order_Details_Tax_Exempt' | translateWF: 'Tax Exempt' }}</th>
                    }
                    <th>{{ 'Purchase_Order_Details_Total_Item_Price' | translateWF: 'Total Item Price' }}</th>
                    @if (canEdit()) {
                      <th></th>
                    }
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item let-i="rowIndex">
                  <tr>
                    <td colspan="4" pTooltip="{{ item.controls.longDescription.value }}" tooltipPosition="top">
                      <b> ({{ item.controls.itemCode.value }}) </b>
                      <p style="max-width: 600px">
                        {{ item.controls.longDescription.value }}
                      </p>
                    </td>
                    @if (this.followsStandardFlow && (this.quotation || this.associatedRequisitions.length > 0)) {
                      <td>
                        <p-select [formControl]="item.controls.owner" [options]="associatedRequisitionsInEntityKeyFormat" optionLabel="number" dataKey="reference"></p-select>
                      </td>
                    }
                    <td>
                      <p-inputGroup>
                        <p-inputnumber
                          [formControl]="item.controls.quantity"
                          [class.ng-invalid]="item.controls.quantity.invalid"
                          [class.ng-dirty]="true"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                        />
                        <p-inputGroupAddon> {{ getUnitName(item.controls.uom.value) }} </p-inputGroupAddon>
                      </p-inputGroup>
                    </td>
                    <td>
                      @if (purchaseOrder?.id ? purchaseOrder?.currency != 0 : currency.value != 0) {
                        <!-- Local Currency Input (Editable) - User enters price in HNL -->
                        <p-inputGroup>
                          <p-inputGroupAddon> {{ currentCurrency }} </p-inputGroupAddon>
                          <p-inputnumber
                            [formControl]="item.controls.unitPrice"
                            [class.ng-invalid]="item.controls.unitPrice.invalid"
                            [class.ng-dirty]="true"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="6"
                          />
                        </p-inputGroup>

                        <!-- USD Price (Calculated, Read-only) -->
                        <p-inputGroup class="mt-[1rem]">
                          <p-inputGroupAddon> USD </p-inputGroupAddon>
                          <p-inputnumber [minFractionDigits]="2" [maxFractionDigits]="6" [ngModel]="getValueOnUSD(item.controls.unitPrice.value)" [disabled]="true" />
                        </p-inputGroup>
                      } @else {
                        <!-- USD Only (Editable) -->
                        <p-inputGroup>
                          <p-inputGroupAddon> USD </p-inputGroupAddon>
                          <p-inputnumber
                            [formControl]="item.controls.unitPrice"
                            [class.ng-invalid]="item.controls.unitPrice.invalid"
                            [class.ng-dirty]="true"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="6"
                          />
                        </p-inputGroup>
                      }
                    </td>

                    @if (this.followsStandardFlow) {
                      <td>
                        <p-checkbox [formControl]="item.controls.isTaxExempt" [binary]="true"></p-checkbox>
                      </td>
                    }

                    <td>
                      @if (purchaseOrder?.id ? purchaseOrder?.currency != 0 : currency.value != 0) {
                        <!-- Local Currency Total (Primary display) -->
                        <p-inputGroup>
                          <p-inputGroupAddon> {{ currentCurrency }} </p-inputGroupAddon>
                          <p-inputnumber [formControl]="item.controls.totalPrice" [disabled]="true" />
                        </p-inputGroup>

                        <!-- USD Total (Calculated, Read-only) -->
                        <p-inputGroup class="mt-[1rem]">
                          <p-inputGroupAddon> USD </p-inputGroupAddon>
                          <p-inputnumber [minFractionDigits]="2" [maxFractionDigits]="6" [ngModel]="getValueOnUSD(item.controls.totalPrice.value)" [disabled]="true" />
                        </p-inputGroup>
                      } @else {
                        <!-- USD Only -->
                        <p-inputGroup>
                          <p-inputGroupAddon> USD </p-inputGroupAddon>
                          <p-inputnumber [formControl]="item.controls.totalPrice" [disabled]="true" />
                        </p-inputGroup>
                      }
                    </td>
                    @if (canEdit()) {
                      <td>
                        <p-button variant="text" icon="pi pi-trash" (click)="deleteItemArrayForm(i)" />
                      </td>
                    }
                  </tr>
                </ng-template>

                <ng-template pTemplate="footer">
                  @for (uom of getDistinctUoms(); track $index) {
                    <tr>
                      <td [attr.colspan]="this.followsStandardFlow && (this.quotation || this.associatedRequisitions.length > 0) ? 5 : 4">
                        <b>{{ 'Purchase_Order_Details_Total_Quantity' | translateWF: 'Total Quantity' }}</b>
                      </td>
                      <td>
                        <p-inputgroup>
                          <input class="p-inputtext p-component" [value]="getTotalQuantityByUom(uom)" [disabled]="true" />
                          <p-inputGroupAddon> {{ getUnitName(uom) }} </p-inputGroupAddon>
                        </p-inputgroup>
                      </td>
                      <td [attr.colspan]="this.followsStandardFlow ? (canEdit() ? 4 : 3) : canEdit() ? 3 : 2"></td>
                    </tr>
                  }

                  <tr>
                    <td [attr.colspan]="this.followsStandardFlow ? (this.quotation || this.associatedRequisitions.length > 0 ? 8 : 7) : 6">
                      <h3>{{ 'Purchase_Order_Details_Total_Price' | translateWF: 'Total Price' }}</h3>
                    </td>
                    <td>
                      @if (purchaseOrder?.id ? purchaseOrder?.currency != 0 : currency.value != 0) {
                        <!-- Local Currency Total (Primary) -->
                        <p-inputgroup class="mt-4">
                          <p-inputGroupAddon> {{ currentCurrency }} </p-inputGroupAddon>
                          <p-inputnumber [ngModel]="getTotalPrice" [disabled]="true" />
                        </p-inputgroup>

                        <!-- USD Total (Calculated) -->
                        <p-inputgroup class="mt-4">
                          <p-inputGroupAddon> USD </p-inputGroupAddon>
                          <p-inputnumber [ngModel]="getValueOnUSD(getTotalPrice)" [disabled]="true" />
                        </p-inputgroup>
                      } @else {
                        <!-- USD Only -->
                        <p-inputgroup class="mt-4">
                          <p-inputGroupAddon> USD </p-inputGroupAddon>
                          <p-inputnumber [ngModel]="getTotalPrice" [disabled]="true" />
                        </p-inputgroup>
                      }
                    </td>
                    @if (canEdit()) {
                      <td colspan="1"></td>
                    }
                  </tr>
                </ng-template>
              </p-table>
            } @else {
              <p-table [value]="items.controls" [responsiveLayout]="'scroll'">
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</th>
                    <th colspan="4"></th>
                    <th>{{ 'Purchase_Order_Details_Quantity' | translateWF: 'Quantity' }}</th>
                    <th>{{ 'Purchase_Order_Details_Item_Price' | translateWF: 'Item Price' }}</th>
                    <th>{{ 'Purchase_Order_Details_Total_Item_Price' | translateWF: 'Total Item Price' }}</th>
                    <th></th>
                  </tr>
                </ng-template>
              </p-table>
              <p-panel>
                <p class="text-center">
                  {{ 'Purchase_Order_Details_No_Elements_Included' | translateWF: 'No Elements has been included' }}
                </p>
              </p-panel>
            }
          </p-card>
        </p-panel>

        <!-- Invoices section (Common for both types) -->
        <p-panel [header]="'Purchase_Order_Details_Invoices' | translateWF: 'Invoices'">
          <p-card>
            @for (invoice of invoices; track $index) {
              <div class="invoice">
                <div class="details">
                  <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                    <label>{{ 'Purchase_Order_Details_Invoice_Number' | translateWF: 'Invoice Number' }}</label>
                    <h4 style="margin: 0; text-align: right; min-width: 11.625rem">&nbsp; {{ invoice.invoiceNumber }}</h4>
                  </div>

                  <div>
                    <label>{{ 'Purchase_Order_Details_Save_Date' | translateWF: 'Save Date' }}</label
                    ><input type="text" class="p-inputtext p-component" [value]="formatDate(purchaseOrder?.createdDate ?? currentDate)" [disabled]="true" />
                  </div>
                  <div>
                    <label>{{ 'Purchase_Order_Details_Total_Amount' | translateWF: 'Total Amount' }}</label>
                    <input type="text" class="p-inputtext p-component" [value]="getInvoiceTotalAmount(invoice)" [disabled]="true" />
                  </div>
                </div>
                <div class="file-container">
                  <div class="file-header">
                    <label class="file-label">{{ 'Purchase_Order_Details_Files' | translateWF: 'Files' }}</label>
                    <p-button
                      variant="text"
                      icon="pi pi-ellipsis-h
                  "
                      (click)="openmodalpurchaseorder()"
                    />
                  </div>
                </div>
              </div>
            } @empty {
              <p-message severity="secondary" [text]="'Purchase_Order_Details_No_Linked_Invoices' | translateWF: 'No Linked Invoices'" class="text-center"> </p-message>
            }
          </p-card>
        </p-panel>

        <!-- Files section (Common for both types) -->
        <p-panel [header]="'Purchase_Order_Details_Files' | translateWF: 'Files'">
          <p-card>
            @if (!purchaseOrder) {
              <p>{{ 'Purchase_Order_Details_Save_To_Upload' | translateWF: 'Save purchase order to upload files' }}</p>
            } @else {
              <div class="files-content">
                @if (canEdit()) {
                  <div class="drag-and-drop">
                    <ngx-file-drop [showBrowseBtn]="false" (onFileDrop)="uploadFiles($event)">
                      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                        <div class="drop-content">
                          <p class="title">
                            <b>{{ 'Purchase_Order_Details_Drag_And_Drop' | translateWF: 'Drag and drop' }}</b>
                          </p>
                          <p class="or-text">{{ 'Purchase_Order_Details_Or' | translateWF: 'or' }}</p>
                          <p-button
                            [label]="'Purchase_Order_Details_Browse_File' | translateWF: 'Browse File'"
                            icon="pi pi-download"
                            variant="outlined"
                            (onClick)="openFileSelector()"
                          ></p-button>
                        </div>
                      </ng-template>
                    </ngx-file-drop>
                  </div>
                }
                <div class="uploaded-files">
                  <div class="under__line">
                    <h4>{{ 'Purchase_Order_Details_Uploaded' | translateWF: 'Uploaded' }}</h4>
                  </div>
                  <p-scrollpanel [style]="{ width: '100%', height: '250px' }">
                    <ul>
                      @for (file of this.purchaseOrder.files; track $index) {
                        <li class="mb-5">
                          <div class="info">
                            <p class="type">
                              <b>{{ file.name.split('.').pop() }}</b>
                            </p>
                            <a (click)="viewFile(file.presignedUrl)" class="file-name">{{ getFileName(file.name) }}</a>
                          </div>
                          <div class="actions">
                            <p-button icon="pi pi-trash" variant="text" (onClick)="deleteFile(file)" />
                          </div>
                        </li>
                      } @empty {
                        <li>
                          <p>{{ 'Purchase_Order_Details_No_Files_Uploaded' | translateWF: 'No files uploaded' }}</p>
                        </li>
                      }
                    </ul>
                  </p-scrollpanel>
                </div>
              </div>
            }
          </p-card>
        </p-panel>
      </div>

      <!-- Right panel - Work Order Details Drawer (Yarn Purchase Orders Only) -->
      @if (isYarnPurchaseOrder) {
        <div
          class="drawer-container"
          [ngClass]="{
            'span-4': drawerView,
            'span-1': !drawerView,
          }"
        >
          <p-button
            [ngClass]="{ 'rotate-180': drawerView }"
            [rounded]="true"
            [raised]="true"
            [outlined]="true"
            icon="pi pi-angle-right"
            class="transition-all drawer-toggle"
            [class.drawer-open]="drawerView"
            (click)="drawerView = !drawerView"
          />

          @if (drawerView) {
            <div class="drawer" @fadeInRight @fadeOutRight>
              <p-scrollpanel [style]="{ width: '100%', height: '100%' }">
                @for (associateWorkOrder of associateWorkOrders; track $index) {
                  <div class="pb-5 border-b">
                    <div class="row-between-center w-full">
                      <h2 class="py-3">{{ associateWorkOrder.orderNumber }}</h2>
                      <p-button [label]="'Common_Populate' | translateWF: 'Populate'" (onClick)="autoPopulateWOIntoItems(associateWorkOrder)" />
                    </div>
                    <div class="card" *ngFor="let fabric of associateWorkOrder.fabrics">
                      <div class="card__header">
                        <div>
                          <h2>{{ fabric.quantityInUOM | number: '1.2-2' }} {{ getUnitName(associateWorkOrder.uom) }}</h2>
                          <h2 *ngIf="associateWorkOrder.uom !== 3">{{ fabric.quantityInPounds | number: '1.2-2' }} lb</h2>
                        </div>

                        <h2>{{ fabric.fabricCode }}</h2>
                      </div>

                      <div class="card__subtitle">
                        @if (fabric && fabric.fabric) {
                          <p class="text-wrap text-sm">
                            {{ fabric.fabric.longDescription }}
                          </p>
                        }
                      </div>

                      <div class="card__content">
                        @if (fabric && fabric.fabric) {
                          <p-table [value]="getAggregatedYarnDetails(fabric.fabric.greige.yarnDetails, associateWorkOrder.id, fabric.fabricCode)" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                              <tr class="cs-datatable-header-dark">
                                <td class="p-2">
                                  {{
                                    'Purchase_Order_Details_Item_Master_Code_Yarn'
                                      | translateWF
                                        : 'Item Master
                          Code for Yarn'
                                  }}
                                </td>
                                <td class="p-2">{{ 'Purchase_Order_Details_Percentage' | translateWF: 'Percentage' }}</td>
                                <td class="p-2">{{ 'Purchase_Order_Details_Qty' | translateWF: 'Qty' }}</td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-yarn>
                              <tr>
                                <td class="p-2 text-sm">
                                  <b> ({{ getYarnCodeItemMasterCode(yarn.uniqueKey) }}) </b>
                                  {{ yarn.yarn?.longDescription }}
                                  <div class="flex flex-wrap gap-2">
                                    <p-tag severity="info" *ngFor="let certification of getYarnCertifications(yarn.yarnCode, associateWorkOrder, fabric.fabricCode)">{{
                                      certification.name
                                    }}</p-tag>
                                  </div>
                                </td>
                                <td class="p-2 text-sm">{{ yarn.usePercentage }}%</td>
                                <td class="p-2 text-sm" [pTooltip]="knittingWithLossInfo">
                                  {{ getKnittingWithLoss((yarn.usePercentage * fabric.quantityInPounds) / 100, fabric, associateWorkOrder.orderType) | number: '1.2-2' }}
                                </td>
                                <ng-template #knittingWithLossInfo>
                                  <div class="row-start-center">
                                    <span>{{
                                      'knittingWithLossInfo'
                                        | translateWF
                                          : 'Quantity including knitting, dyeing and
                              finishing loss'
                                    }}</span>
                                  </div>
                                </ng-template>
                              </tr>
                            </ng-template>
                          </p-table>
                        }
                      </div>
                    </div>
                  </div>
                } @empty {
                  <p-panel>
                    <p class="text-center">
                      {{
                        'Purchase_Order_Details_No_Linked_Work_Orders'
                          | translateWF
                            : 'No Linked Work
                Orders'
                      }}
                    </p>
                  </p-panel>
                }
              </p-scrollpanel>
            </div>
          }
        </div>
      }

      @if (followsStandardFlow && selectedQuotation) {
        <div
          class="drawer-container"
          [ngClass]="{
            'span-4': drawerView,
            'span-1': !drawerView,
          }"
        >
          <p-button
            [ngClass]="{ 'rotate-180': drawerView }"
            [rounded]="true"
            [raised]="true"
            [outlined]="true"
            icon="pi pi-angle-right"
            class="transition-all drawer-toggle"
            [class.drawer-open]="drawerView"
            (click)="drawerView = !drawerView"
          />

          @if (drawerView) {
            <div class="drawer" @fadeInRight @fadeOutRight>
              <p-scrollpanel [style]="{ width: '100%', height: '100%' }">
                <!-- Quotation Details Section -->
                <div class="pb-5 border-b mb-4">
                  <h2 class="py-3 text-lg font-bold text-primary">
                    {{ 'Purchase_Order_Details_Quotation_Details' | translateWF: 'Quotation Details' }}
                  </h2>
                  <div class="bg-white p-4 rounded-lg shadow-sm">
                    <div class="grid-2 gap-3 text-sm">
                      <div>
                        <p class="text-gray-500">{{ 'Purchase_Order_Details_Number' | translateWF: 'Number' }}:</p>
                        <p class="font-semibold">{{ selectedQuotation.number }}</p>
                      </div>
                      <div>
                        <p class="text-gray-500">{{ 'Purchase_Order_Provider' | translateWF: 'Provider' }}:</p>
                        <p class="font-semibold">{{ selectedQuotation.providerName }}</p>
                      </div>
                      <div>
                        <p class="text-gray-500">{{ 'Purchase_Order_Details_Currency' | translateWF: 'Currency' }}:</p>
                        <p class="font-semibold">{{ currencyEnum[selectedQuotation.currency] }}</p>
                      </div>
                      <div>
                        <p class="text-gray-500">{{ 'ExchangeRate' | translateWF: 'Exchange Rate' }}:</p>
                        <p class="font-semibold">{{ selectedQuotation.exchangeRateToUSD | number: '1.4-4' }}</p>
                      </div>
                      <div>
                        <p class="text-gray-500">{{ 'Purchase_Order_Details_Expiration' | translateWF: 'Expiration' }}:</p>
                        <p class="font-semibold">{{ selectedQuotation.expirationDate | date }}</p>
                      </div>
                      <div>
                        <p class="text-gray-500">{{ 'Purchase_Order_Details_Total_Items' | translateWF: 'Total Items' }}:</p>
                        <p class="font-semibold">{{ selectedQuotation.items.length }}</p>
                      </div>
                    </div>

                    <!-- Items from Quotation -->
                    <div class="mt-4">
                      <h4 class="font-semibold mb-2">{{ 'Purchase_Order_Items' | translateWF: 'Items' }}</h4>
                      <p-table [value]="selectedQuotation.items" [scrollable]="true" scrollHeight="200px">
                        <ng-template pTemplate="header">
                          <tr class="cs-datatable-header-dark">
                            <th class="p-2">{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</th>
                            <th class="p-2">{{ 'Purchase_Order_Details_Unit_Price' | translateWF: 'Unit Price' }}</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item>
                          <tr>
                            <td class="p-2 text-sm">{{ item.itemCode }}</td>
                            <td class="p-2 text-sm">{{ item.unitPrice | currency }}</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </div>

                <!-- Requisitions Details Section -->
                @if (associatedRequisitions.length > 0) {
                  <div class="pb-5">
                    <h2 class="py-3 text-lg font-bold text-primary">
                      {{ 'Purchase_Order_Details_Requisitions_Details' | translateWF: 'Requisitions Details' }}
                    </h2>

                    @for (requisition of associatedRequisitions; track requisition.id; let idx = $index) {
                      <div class="requisition-detail-card mb-4 bg-white p-4 rounded-lg shadow-sm">
                        <div class="row-between-stretch items-start mb-3">
                          <div>
                            <h3 class="font-bold text-base">{{ requisition.number }}</h3>
                            @if (idx === 0) {
                              <p-tag [value]="'Purchase_Order_Details_Original' | translateWF: 'Original'" severity="info" class="mt-1" />
                            }
                          </div>
                        </div>

                        <div class="grid-2-sm mb-3 text-sm">
                          <div>
                            <p class="text-gray-500">{{ 'Purchase_Order_Details_Department' | translateWF: 'Department' }}:</p>
                            <p class="font-semibold">{{ requisition.departmentName || 'N/A' }}</p>
                          </div>
                          <div>
                            <p class="text-gray-500">{{ 'Purchase_Order_Details_Created_By' | translateWF: 'Created By' }}:</p>
                            <p class="font-semibold">{{ requisition.createdBy || 'N/A' }}</p>
                          </div>
                          <div>
                            <p class="text-gray-500">{{ 'Purchase_Order_Status' | translateWF: 'Status' }}:</p>
                            <p class="font-semibold">{{ requisition.statusName?.en || requisition.statusName?.es || 'N/A' }}</p>
                          </div>
                          <div>
                            <p class="text-gray-500">{{ 'Purchase_Order_Details_Total_Items' | translateWF: 'Total Items' }}:</p>
                            <p class="font-semibold">{{ requisition.entries.length || 0 }}</p>
                          </div>
                          @if (requisition.destinationLocationName || requisition.destinationLocationCode) {
                            <div class="span-2">
                              <p class="text-gray-500">{{ 'Destination_Warehouses' | translateWF: 'Destination Warehouse' }}:</p>
                              <p-tag
                                [value]="requisition.destinationLocationName?.en || requisition.destinationLocationName?.es || requisition.destinationLocationCode"
                                severity="info"
                                icon="pi pi-warehouse"
                              />
                            </div>
                          }
                        </div>

                        <div class="mt-3">
                          <h4 class="font-semibold text-sm mb-2">
                            {{ 'Purchase_Order_Details_Items_In_Quotation' | translateWF: 'Items in Quotation' }}
                          </h4>
                          <p-table [value]="getRequisitionItemsInQuotation(requisition)" [scrollable]="true" scrollHeight="150px">
                            <ng-template pTemplate="header">
                              <tr class="cs-datatable-header-dark">
                                <th class="p-2 text-xs">{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</th>
                                <th class="p-2 text-xs">{{ 'Purchase_Order_Details_Qty_Requested' | translateWF: 'Qty Requested' }}</th>
                                <th class="p-2 text-xs">{{ 'Purchase_Order_Details_Unit_Price' | translateWF: 'Unit Price' }}</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-entry>
                              <tr>
                                <td class="p-2 text-xs">
                                  <b>{{ entry.itemCode }}</b>
                                </td>
                                <td class="p-2 text-xs">{{ entry.quantity }} {{ getUnitName(entry.uom) }}</td>
                                <td class="p-2 text-xs">{{ getQuotationPrice(entry.itemCode) | currency }}</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  <p-panel>
                    <p class="text-center text-gray-500">
                      {{
                        'Purchase_Order_Details_No_Linked_Requisitions'
                          | translateWF
                            : 'No
                Linked Requisitions'
                      }}
                    </p>
                  </p-panel>
                }
              </p-scrollpanel>
            </div>
          }
        </div>
      }
    </div>
  </div>
</main>
